import { type ForwardedRef, forwardRef } from 'react'
import type { PatternFormatProps } from 'react-number-format'
import { PatternFormat } from 'react-number-format'

import type { InputProps } from '@/_components/ui/input'
import { Input } from '@/_components/ui/input'

type CpfInputProps = Omit<Partial<PatternFormatProps<InputProps>>, 'onChange'> & {
  onChange?: (value: string) => void
}

export const CpfInput = forwardRef(
  ({ onChange, ...props }: CpfInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <PatternFormat
        {...props}
        format="###.###.###-##"
        customInput={Input}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange?.(values.value)
        }}
      />
    )
  },
)

CpfInput.displayName = 'CpfInput'
